import api from '../api'
import { Template, TemplateState, TemplateSummary } from './templateModel'

export const getTemplate = async (id: number): Promise<Template> => {
  return (await api.get<Template>(`/web/templates/${id}`)).data
}

export const getDeletedTemplate = async (id: number): Promise<Template> => {
  return (await api.get<Template>(`/web/templates/deleted/${id}`)).data
}

export type SaveTemplateResponse = {
  id: number
}

export const saveTemplateEndpoint = `/web/templates`

export const saveTemplate = async (id: number, changeSet: TemplateState) => {
  return (await api.post<SaveTemplateResponse>(saveTemplateEndpoint, {id, ...changeSet})).data
}

export const deleteTemplate = async (id: number) => {
  await api.delete(`/templates/${id}`)
}

export const restoreTemplate = async (id: number) => {
  await api.post(`/templates/restore/${id}`)
}

export const getAllTemplates = async (): Promise<TemplateSummary[]> => {
  return (await api.get<TemplateSummary[]>(`/templates`)).data
}

export const getAllDeletedTemplates = async (): Promise<TemplateSummary[]> => {
  return (await api.get<TemplateSummary[]>(`/templates/deleted`)).data
}